module.exports = __webpack_public_path__ + "assets/1ee0009a7a7d1c116b3472ce091edfde.mp3";